export default __webpack_public_path__ + "e1020643225e2ab67eba4bf020345738.png";